
import { EntitysSelectors } from "@shared/src/enums/EntitysSelectors";
import { EntitySelectorDto } from "../EntitySelectorDto";

export class AddressImageEntitySelectorDto extends EntitySelectorDto {

	public static new(activeFilterKeys: Array<String>): AddressImageEntitySelectorDto{
        let result: AddressImageEntitySelectorDto = new AddressImageEntitySelectorDto();
		result.loadData(EntitysSelectors.AddressImage, "", activeFilterKeys, 0, false);
        return result;
    }

    public getUrlGoToMaintenance(): string {
		//No hi ha manteniment estricte
		return "activity/address";
	}

	public getUrlBack(): string {
		return "/maintenance/address/image";
	}
	
}